<script setup lang="ts">
/** Aventross AGM (Audited) — 원본 합본 문서 3부((Incorporated In Singapore)). gen_vue 로 템플릿 글자 그대로 생성. */
import CddVarField from '../../../aura/agm/cdd/CddVarField.vue';
import DocScope from '../../../aura/agm/cdd/DocScope.vue';
import AgmSigners from '../../../aura/agm/cdd/AgmSigners.vue';
import { useRepeat } from '../useRepeat';
import '../../../aura/agm/docs/agmDoc.css';
import '../avDoc.css';

const R = useRepeat();
void CddVarField; void DocScope; void AgmSigners;
</script>

<template>
  <div class="agm-doc av-doc">
    <p class="doc-p center bold"><CddVarField field-key="company_name" label="Company Name" /></p>
    <p class="doc-p center">(Incorporated In Singapore)</p>
    <p class="doc-p center">Company Registration No. <CddVarField field-key="company_registration_no" label="Company Registration No." /></p>
    <div class="gap" />
    <p class="doc-p center bold">AGREEMENT BY MEMBERS TO SHORTER NOTICE</p>
    <p class="doc-p center bold"> FOR THE ANNUAL GENERAL MEETING</p>
    <p class="doc-p center bold">(PURSUANT TO SECTION 177(3) &amp; 203(2) OF THE COMPANIES ACT 1967)</p>
    <div class="gap" />
    <p class="doc-p">We, undersigned, being the shareholders do hereby consent to the Annual General Meeting held even though the Annual General Meeting is called by shorter notice than 14 days specified in the Companies Act and the Constitution of the Company and hereby agree to the Annual General Meeting of the Company to be held on:</p>
    <div class="gap" />
    <p class="doc-p">Date: <CddVarField field-key="agm_date" label="AGM date" /></p>
    <div class="gap" />
    <p class="doc-p">Time: 10:00 am</p>
    <div class="gap" />
    <p class="doc-p">Venue: <CddVarField field-key="agm_venue" label="AGM venue" /></p>
    <div class="gap" />
    <p class="doc-p">Dated, <CddVarField field-key="agm_date" label="AGM date" /></p>
    <div class="gap" />
    <p class="doc-p center bold">SHAREHOLDERS</p>
    <div class="gap" />
    <template v-for="id_mem in R.ids('mem')" :key="'mem' + id_mem">
      <DocScope :scope="'mem_' + id_mem + '/'">
        <div class="rep-item"><div class="rep-bar"><span>Member #{{ id_mem }}</span><button type="button" class="rep-rm" title="Remove" @click="R.remove('mem', id_mem)">×</button></div>
          <p class="doc-p center bold">_______________________________________</p>
          <p class="doc-p center"><CddVarField field-key="member_name" label="Member" /></p>
          <div class="gap" />
        </div>
      </DocScope>
    </template>
    <button type="button" class="rep-add" @click="R.add('mem')">+ Add member</button>
    <div class="gap" />
  </div>
</template>
